import { createSlice } from "@reduxjs/toolkit";
import { defaultUserPermissions } from "../constants/page";

export const permissionsSlice = createSlice({
  name: "permissions",
  initialState: defaultUserPermissions,
  reducers: {
    updatePermissions: (state, action) => {
      state[action.payload] = !state[action.payload];
    },
    setPermissions: (state, action) => {
      const payload = action.payload;
      if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
        return;
      }

      state.userUUID = payload.userUUID;

      for (const [key, value] of Object.entries(payload)) {
        state[key] = value;
      }
    },
  },
});

export const { updatePermissions, setPermissions } = permissionsSlice.actions;

export default permissionsSlice.reducer;
